if (!customElements.get('promo-banner')) {
  class PromoBanner extends HTMLElement {
    connectedCallback() {
      this.btn = this.querySelector('.js-promo-code');
      this.liveRegion = this.querySelector('.js-copy-live');
      if (!this.btn) return;

      if (navigator.clipboard && navigator.clipboard.writeText) {
        this.btn.addEventListener('click', this.copyCode.bind(this));
      } else {
        this.btn.classList.add('promo-banner__code--static');
        this.btn.disabled = true;
      }
    }

    copyCode() {
      navigator.clipboard.writeText(this.btn.dataset.code).then(() => {
        this.btn.classList.add('is-copied');
        if (this.liveRegion) this.liveRegion.textContent = this.btn.dataset.copiedText;

        clearTimeout(this.copyTimer);
        this.copyTimer = setTimeout(() => {
          this.btn.classList.remove('is-copied');
          if (this.liveRegion) this.liveRegion.textContent = '';
        }, 2000);
      });
    }
  }

  customElements.define('promo-banner', PromoBanner);
}
